module.exports = __webpack_public_path__ + "assets/img/loading.b4d29153.gif";